// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"Cards_cardsContainer__prY-G","notResult":"Cards_notResult__2yKCc","button":"Cards_button__ZIPse","link":"Cards_link__3WhTc"};